import { Theme } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';
import moment from 'moment';
import React, { CSSProperties, useMemo } from 'react';

import { Label, Space } from '@/components';

const useStyles = makeStyles((theme: Theme) => ({
  day: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1.5),
  },
}));

export interface TransactionsDateProps {
  'data-test'?: string;
  style: CSSProperties;
  value: Date;
}

const TransactionsDate: React.FC<TransactionsDateProps> = ({ value, style, 'data-test': dataTest }) => {
  const classes = useStyles();
  const formatted = useMemo(() => {
    const date = moment(value);
    return date.format(date.year() === moment().year() ? 'D MMMM' : 'D MMMM YYYY').toUpperCase();
  }, [value]);
  return (
    <Space style={style}>
      <Label data-test={dataTest} className={classes.day}>
        {formatted}
      </Label>
    </Space>
  );
};

export default TransactionsDate;
